import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">平台特色</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-6 transition-all hover:border-accent-200/60"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}